import React from 'react'
import { AppstoreOutlined } from '@ant-design/icons'
import './SupportedTypes.scss'

interface Category {
  label: string
  color: string
  bg: string
  members: string[]
}

const CATEGORIES: Category[] = [
  {
    label: '施工 · 质检',
    color: '#2E6BE6',
    bg: '#EAF1FE',
    members: [
      '施工验收台账',
      '施工日志',
      '监理日报',
      '检验批记录',
      '工程签证单'
    ]
  },
  {
    label: '安全 · 巡检',
    color: '#D9870B',
    bg: '#FBEFD6',
    members: [
      '工地巡检报告',
      '隐患排查表',
      '整改通知书',
      '6S 检查记录',
      '现场见证单'
    ]
  },
  {
    label: '物料 · 物流',
    color: '#16A06E',
    bg: '#E6F6EF',
    members: ['到货验收记录', '转运明细单', '裁桩收方表', '桩基影像记录']
  },
  {
    label: '行政 · 设备',
    color: '#6E3AF2',
    bg: '#F1ECFE',
    members: [
      '考勤打卡表',
      '外勤巡查记录',
      '车辆油耗台账',
      '用车报销单',
      '设备点检表',
      '项目周报'
    ]
  }
]

export default function SupportedTypes({
  onPick
}: {
  onPick?: (name: string) => void
}) {
  return (
    <div className="aiClerk-types">
      {CATEGORIES.map((cat) => (
        <div className="aiClerk-types__cat" key={cat.label}>
          <div
            className="aiClerk-types__cat-label"
            style={{ color: cat.color }}
          >
            <span
              className="aiClerk-types__cat-bar"
              style={{ background: cat.color }}
            />
            {cat.label}
          </div>
          <div className="aiClerk-types__chips">
            {cat.members.map((member) => (
              <span
                className={`aiClerk-types__chip${
                  onPick ? ' aiClerk-types__chip--clickable' : ''
                }`}
                key={member}
                style={{ color: cat.color, background: cat.bg }}
                role={onPick ? 'button' : undefined}
                onClick={onPick ? () => onPick(member) : undefined}
              >
                {member}
              </span>
            ))}
          </div>
        </div>
      ))}
      <div className="aiClerk-types__foot">
        <span className="aiClerk-types__foot-text">
          以上仅为常见类型 · 持续上新
        </span>
        <span
          className="aiClerk-types__foot-chip"
          style={{ color: '#6E3AF2', background: '#F1ECFE' }}
        >
          <AppstoreOutlined />
          200+ 种行业模板支持
        </span>
      </div>
    </div>
  )
}
